

















































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
    Header,
    Loading,
    ArrowRightIcon,
    SquareEditOutlineIcon,
  },
  data() {
    return {
      boardContext: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      boards: (state: any) => state.boards.boards,
      allBoardSections: (state: any) => state.boardSections.board_sections,
    }),
    board_sections: function(): any {
      if (this.boardContext === null) {
        return this.allBoardSections;
      } else {
        return this.allBoardSections.filter((boardSection: any) => {
          if (boardSection.boardByBoardId) {
            return boardSection.boardByBoardId.id === this.boardContext.id;
          } else {
            return false;
          }
        });
      }
    },
  },
  async mounted() {
    this.loaded = false;
    this.$store.dispatch('PULL_BOARD_SECTIONS');
    this.loaded = true;
    this.$store.dispatch('PULL_BOARDS');
  },
});
